import { CardContent } from "@/components/ui/card";
import { X, Lightbulb } from "lucide-react";
import React from "react";

interface SetInfoHelperProps {
  onClose: () => void;
}

const SetInfoHelper: React.FC<SetInfoHelperProps> = ({ onClose }) => (
  <CardContent className="mb-0 py-0">
    <div className="flex flex-col px-4 py-6 rounded-xl relative bg-accent-fg-cold">
      <button
        onClick={onClose}
        className="absolute top-2 right-2 p-1 rounded-full hover:bg-white transition-colors text-tx-dark"
        aria-label="Close helper"
      >
        <X size={16} />
      </button>
      <div className="flex items-start w-full text-left pr-3">
        <Lightbulb size={20} className="mr-3 shrink-0 mt-0.5 text-tx-dark" />
        <p className="text-sm text-tx-dark">
          A "set" is a group of consecutive repetitions of an exercise performed
          without breaks, followed by rest before the next set.
        </p>
      </div>
    </div>
  </CardContent>
);

export default SetInfoHelper;
